module.exports = __webpack_public_path__ + "static/media/marek_wolfryd_3.55f2779b.jpg";